export default "__VITE_ASSET__e896908c__"